/**
 * Which single action a tile leads with, across the whole platform.
 *
 * The panel used to prefer Visit site and put Enquire in its place when the
 * item carried no external site. That reads as one design, but it measures as
 * two: a tile showing Enquire is a tile whose supplier has no website, so the
 * two buttons were never being compared on comparable items, and no split of
 * the numbers could say which of them earns its corner.
 *
 * So it is a choice, not a fallback. One of the two is offered, the same one
 * everywhere, and an item that cannot supply it shows nothing rather than the
 * other — an empty corner is a clean miss, and the reader still has Save,
 * Share and the tile's own link.
 *
 * Flipping this constant is the whole of the experiment.
 */
export type TilePrimaryAction = 'website' | 'enquiry';

export const TILE_PRIMARY_ACTION: TilePrimaryAction = 'website';
